import {useForm} from 'react-hook-form';
import {useDialogContext} from '@ui/overlays/dialog/dialog-context';
import {Dialog} from '@ui/overlays/dialog/dialog';
import {DialogHeader} from '@ui/overlays/dialog/dialog-header';
import {Trans} from '@ui/i18n/trans';
import {DialogBody} from '@ui/overlays/dialog/dialog-body';
import {Form} from '@ui/forms/form';
import {DialogFooter} from '@ui/overlays/dialog/dialog-footer';
import {Button} from '@ui/buttons/button';
import React, {Fragment, useEffect} from 'react';
import {FormSelect, Option, OptionGroup} from '@ui/forms/select/select';
import {useAddHosters} from '@common/auth/ui/account-settings/basic-info-panel/add-hosters';
import {FormTextField} from '@ui/forms/input-field/text-field/text-field';
import {HostAcc} from '@app/titles/models/HostAcc';
import {Link} from 'react-router-dom';
import {FormSwitch} from '@ui/forms/toggle/switch';

export function DebridorsAddAccount({account}: {account?: HostAcc}) {
  const form = useForm<HostAcc>();
  const addHosters = useAddHosters(form);
  const {formId, close} = useDialogContext();
  const [provider, setProvider] = React.useState(0);
  useEffect(() => {
    if (account) {
      if (account.id_host && account.id_host > 0) {
        if (account.id_host === 2) {
          form.setValue('provider', '4');
        } else if (account.id_host === 5) {
          form.setValue('provider', '5');
        } else if (account.id_host === 36) {
          form.setValue('provider', '6');
        } else if (account.id_host === 37) {
          form.setValue('provider', '7');
        }
      }
      if (account.provider) {
        form.setValue('provider', account.provider.toString());
      }
      form.setValue('api', account.api);
      form.setValue('active', account.active);
      form.setValue('id', account.id);
    }
  }, [account]);
  return (
    <Dialog size={'xl'}>
      <DialogHeader>
        <Trans message={account ? 'Edit Account' : 'Add Account'} />
      </DialogHeader>
      <DialogBody>
        <Form
          form={form}
          onSubmit={newDetails => {
            addHosters.mutate(newDetails, {
              onSuccess: async () => {
                close();
              },
            });
          }}
          id={formId}
        >
          <div className={'w-full'}>
            <FormSelect
              className="mb-20 w-full"
              selectionMode="single"
              required={true}
              name={'provider'}
              onSelectionChange={value => {
                setProvider(parseInt(value as string));
              }}
              label={<Trans message="Provider" />}
            >
              <OptionGroup label={'Debrideurs'}>
                <Option value="1">Debrid-link.com</Option>
                <Option value="2">Alldebrid.com</Option>
                <Option value="3">Real-debrid.com</Option>
              </OptionGroup>
              <OptionGroup label={'Hosters'}>
                <Option value="4">Darkibox.com</Option>
                <Option value="5">1fichier.com</Option>
                <Option value="6">Send.cm</Option>
                <Option value="7">Media.cm</Option>
              </OptionGroup>
            </FormSelect>
          </div>
          <div className={'w-full'}>
            <FormTextField
              type={'hidden'}
              name={'id'}
              value={account ? account.id : undefined}
            />

            <FormTextField
              inputElementType={'input'}
              name={'api'}
              label={'API'}
              required={true}
              description={
                provider > 0 ? (
                  <Fragment>
                    <Trans message={'You can get it here'} /> {' : '}
                    <Link
                      to={
                        provider === 1
                          ? 'https://debrid-link.com/webapp/apikey'
                          : provider === 2
                            ? 'https://alldebrid.com/apikeys/'
                            : provider === 3
                              ? 'https://real-debrid.com/apitoken'
                              : provider === 4
                                ? 'https://darkibox.com/my_account.html'
                                : provider === 5
                                  ? 'https://1fichier.com/console/params.pl'
                                  : provider === 6
                                    ? 'https://send.cm/?op=my_account'
                                    : 'https://media.cm/?op=my_account'
                      }
                      target="_blank"
                    >
                      {provider === 1
                        ? 'https://debrid-link.com/webapp/apikey'
                        : provider === 2
                          ? 'https://alldebrid.com/apikeys/'
                          : provider === 3
                            ? 'https://real-debrid.com/apitoken'
                            : provider === 4
                              ? 'https://darkibox.com/my_account.html'
                              : provider === 5
                                ? 'https://1fichier.com/console/params.pl'
                                : provider === 6
                                  ? 'https://send.cm/?op=my_account'
                                  : 'https://media.cm/?op=my_account'}
                    </Link>
                  </Fragment>
                ) : null
              }
            />
          </div>
          <FormSwitch name={'active'} className="mt-24">
            <Trans message="Active" />
          </FormSwitch>
        </Form>
      </DialogBody>
      <DialogFooter>
        <Button
          form={formId}
          variant="flat"
          color="primary"
          type="submit"
          disabled={addHosters.isPending}
        >
          <Trans message="Save Account" />
        </Button>
        <Button onClick={() => close()}>
          <Trans message="Close" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
